module.exports = __webpack_public_path__ + "img/hydrograph.6cdfcc4b.svg";